import {
  COLLECTION_PLATFORM_METRIC_COLUMN_WIDTH,
  COLLECTION_PLATFORM_TIPO_COLUMN_WIDTH,
} from "./collectionContentTableConstants";

/**
 * Canonical column order for collection content tables:
 *
 * 1. Identity — Fecha → [Cuenta] → Tipo/Plataforma → Imagen/Snapshot → Contenido/Título
 * 2. Context — table-specific (Marca, Posición, Placement, …)
 * 3. Metrics — Vistas, Duración, live stats, …
 * 4. Actions — Detalles
 */
export const COLLECTION_CONTENT_IDENTITY_COLUMN_ORDER = [
  "date",
  "account",
  "platformType",
  "thumbnail",
  "title",
] as const;

export type CollectionContentIdentityColumn =
  (typeof COLLECTION_CONTENT_IDENTITY_COLUMN_ORDER)[number];

/**
 * Contenido tables fit the card (100%). Fixed cols keep preferred widths;
 * fluid Título absorbs leftover space. minWidth enables horizontal scroll on
 * small screens instead of overlapping cells.
 */
export const collectionContenidoTableSx = {
  tableLayout: "fixed" as const,
  width: "100%",
  minWidth: 720,
} as const;

/**
 * Platform / livestream summary tables — stable column widths:
 *
 * - Tipo (left) + metrics (right) keep fixed px widths
 * - Middle `.platform-table-spacer` grows on large screens so metrics sit flush right
 * - Table minWidth = Tipo + up to 8 metric cols → TableContainer scrolls on sm
 */
export const collectionPlatformMetricsTableSx = {
  tableLayout: "fixed" as const,
  width: "100%",
  minWidth:
    COLLECTION_PLATFORM_TIPO_COLUMN_WIDTH +
    COLLECTION_PLATFORM_METRIC_COLUMN_WIDTH * 8,
  "& thead th:first-of-type, & tbody td:first-of-type": {
    width: COLLECTION_PLATFORM_TIPO_COLUMN_WIDTH,
    minWidth: COLLECTION_PLATFORM_TIPO_COLUMN_WIDTH,
    maxWidth: COLLECTION_PLATFORM_TIPO_COLUMN_WIDTH,
    boxSizing: "border-box",
    overflow: "hidden",
  },
  "& thead th:not(:first-of-type):not(.platform-table-spacer), & tbody td:not(:first-of-type):not(.platform-table-spacer)":
    {
      width: COLLECTION_PLATFORM_METRIC_COLUMN_WIDTH,
      minWidth: COLLECTION_PLATFORM_METRIC_COLUMN_WIDTH,
      maxWidth: COLLECTION_PLATFORM_METRIC_COLUMN_WIDTH,
      boxSizing: "border-box",
      overflow: "hidden",
    },
  "& .platform-table-spacer": {
    width: "auto",
    minWidth: 0,
    maxWidth: "none",
    padding: 0,
  },
} as const;

/** Hover + pointer for rows that open content/mention detail on click. */
export const collectionClickableTableRowSx = {
  cursor: "pointer",
} as const;
